'use strict';

var React = require('react');
var ThemeProviderNoVars = require('./ThemeProviderNoVars.cjs');
var ThemeProviderWithVars = require('./ThemeProviderWithVars.cjs');
var identifier = require('./identifier.cjs');
var jsxRuntime = require('react/jsx-runtime');

function _interopNamespaceDefault(e) {
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n.default = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceDefault(React);

function ThemeProvider({
  theme,
  ...props
}) {
  const noVarsTheme = React__namespace.useMemo(() => {
    if (typeof theme === 'function') {
      return theme;
    }
    const muiTheme = identifier in theme ? theme[identifier] : theme;
    if (!('colorSchemes' in muiTheme)) {
      if (!('vars' in muiTheme)) {
        // For non-CSS variables themes, set `vars` to null to prevent theme inheritance from the upper theme.
        // The example use case is the docs demo that uses ThemeProvider to customize the theme while the upper theme is using CSS variables.
        return {
          ...theme,
          vars: null
        };
      }
      return theme;
    }
    return null;
  }, [theme]);
  if (noVarsTheme) {
    return /*#__PURE__*/jsxRuntime.jsx(ThemeProviderNoVars, {
      theme: noVarsTheme,
      ...props
    });
  }
  return /*#__PURE__*/jsxRuntime.jsx(ThemeProviderWithVars.CssVarsProvider, {
    theme: theme,
    ...props
  });
}

module.exports = ThemeProvider;
//# sourceMappingURL=ThemeProvider.cjs.map
